import React, {Component} from 'react'
import {connect} from "react-redux";
import { auth } from "../../actions";
import { FaHome, FaSignOutAlt } from 'react-icons/fa';
import decode from 'jwt-decode';

import { Nav, Navbar, NavLink, NavbarToggler, Collapse, NavItem } from 'reactstrap';

class Header extends Component {

    constructor(props){
        super(props);
        this.state = {
            isOpen: false,
            nombre_usuario: ''
        };
        this.toggle = this.toggle.bind(this);
    }

    logout(){
        this.props.logout();
        window.location.pathname = '/login';
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    componentDidMount() {
        let token = localStorage.getItem('token_cafe');
        if(!!token){
            let datosToken = decode(token);
            this.setState({nombre_usuario: datosToken.nombre_completo})
        }else{
            this.props.history.push('/login');
        }
    }

    render() {

        return (
            <Navbar light expand="md">
                <NavbarToggler onClick={this.toggle} />
                <Collapse isOpen={this.state.isOpen} navbar>
                    <Nav className="mr-auto" navbar>
                        <NavItem>
                            <NavLink href="/components/" className="font-italic">
                                <FaHome /> Inicio
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className="font-italic" href="/home">General</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className="font-italic" href="/zonas">Zonas</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className="font-italic" href="/usuarios">Usuarios</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className="font-italic" href="/reportes">Reportes</NavLink>
                        </NavItem>
                    </Nav>
                    <Nav className="ml-auto" navbar>
                        <NavItem>
                            <NavLink className="font-italic" href="javascript:void(0);" onClick={()=>this.logout()}>
                                {this.state.nombre_usuario} <FaSignOutAlt/>
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Collapse>
            </Navbar>
        )
    }
}

const mapStateToProps = state => {
    return {
        is_authenticated: state.auth.is_authenticated
    };
};

const mapDispatchToProps = dispatch => {
    return {
        logout: () => {
            return dispatch(auth.logout());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);